import React from 'react';
import PropTypes from 'prop-types';
import { StyledRadio } from 'components';
import { FormControlLabel } from '@mui/material';

const RadioLabel = props => (
    <FormControlLabel
        sx={theme => ({
            fontSize: 16,
            color: theme.palette.grey[600],
            alignItems: 'flex-start',
            ...(typeof props.sx === 'function' ? props.sx(theme) : props.sx),
        })}
        {...props}
        control={<StyledRadio />}
    />
);

RadioLabel.propTypes = {
    sx: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
    controlSx: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
};

export default RadioLabel;
